/**
 * prepareBillModificationGuard — TSK-3303.
 *
 * Once Prepare Bill has created a server-confirmed order (cart.preparedBillOrigin
 * === "Y"), every item-level cart mutation (add, qty change, delete, cancel/void,
 * discount, notes, addon repeat, production-center/sale-type reassignment, fire,
 * copy-KOT, ...) must be blocked unless the till explicitly opts in via
 * posConfig.allowModificationAfterPrepareBill === "Y". Centralized here so every
 * call site checks the same condition instead of re-deriving it.
 */
export function isPrepareBillModificationBlocked(cart, posConfig) {
  return cart?.preparedBillOrigin === "Y" && posConfig?.allowModificationAfterPrepareBill !== "Y";
}

export const PREPARE_BILL_MODIFICATION_BLOCKED_MESSAGE = "Bill is already prepared. Item modifications are not allowed.";
